import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { columnasComprobantes } from "./columnasComprobantes";
import {
  Table,
  Text,
  TextButton,
  PrimaryButton,
  OutlineButton,
  Breadcrumb,
  Badge,
  IconButton,
} from "@artprov/design-system";
import { NuevaSolicitudModal } from "./NuevaSolicitudModal";
import { MessagesModal } from "./MessagesModal";
import { createSolicitud } from "../../../services/mis-solicitudes/solicitudesService";
import ModalComprobante from "../../autorizaciones/components/autorizacion/Contenido/ModalComprobante";

/**
 * @typedef {Object} Data
 * @property {string} id - Identificador Ãºnico asociado a la solicitud.
 */

/**
 * Componente Contenido.
 * Maneja los datos de una solicitud y permite establecer una nueva solicitud segÃºn sea necesario.
 *
 * @typedef {Object} props
 * @@property {Data} props.data - Objeto que contiene los datos de la solicitud.
 * @@property {function(Data): void} props.onSetNuevosComprobantes - Función para manejar y establecer una nueva solicitud.
 */

export default function Contenido({
  data = {},
  onSetNuevosComprobantes = () => { },
}) {
  const estados = {
    inicial: 0,
    enviar: 1,
    envioExitoso: 2,
    envioErroneo: 3,
    cancelar: 4,
  };

  const { id } = useParams();
  const [openModalFile, setOpenModalFile] = useState(false)
  const [fileToShow, setFileToShow] = useState(null)
  const navigate = useNavigate();
  const location = useLocation();
  const isNumberOne = id === "1";
  const [openModalFiltros, setOpenModalFiltros] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [noEnviarSolicitud, setNoEnviarSolicitud] = useState(true);
  const [openMessagesModal, setOpenMessagesModal] = useState(false);
  const [isSuccessEnvioSolicitud, setIsSuccessEnvioSolicitud] = useState(false);
  const [total, setTotal] = useState(0);
  const [estado, setEstado] = useState(estados.inicial);
  const [datoDelComprobante, setDatoDelComprobante] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);

  const { idTipoSolicitud } = location.state;
  const listadoComprobantes = isNumberOne ? [] : data;
  const listadoComprobantesTabla = listadoComprobantes.map((dato, indice) => {
    return {
      ...dato,
      edit: <IconButton icon="edit" onClick={(e) => {
        dato.indice = indice
        setDatoDelComprobante(dato)
        setOpenModalFiltros(true)
      }} />,
      show: <IconButton icon="upload_file"
        onClick={() => {
          setFileToShow({ ...dato?.file, content: dato?.file?.fileContent });
          setOpenModalFile(true)
        }} />,
      delete: <IconButton icon="delete" disabled />
    }
  })

  // TODO: crear una libreria de redirecciones
  const redirectToMisSolictudes = () => {
    navigate(`/nueva-solicitud/`);
  };

  // TODO: Enviar a utils o reutilizar si existe.
  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const handleDropdownClick = (opcion) => {
    const formattedOption = opcion.toLowerCase().replace(/ /g, "-");
    navigate(`/nueva-solicitud/${formattedOption}`);
  };

  //#region "Modales de alerta"
  const steps = {
    stepWarning: {
      title: "Enviar solicitud",
      message: "Si la enviás, se registrará y pasará a revisión. Esta acción no se puede deshacer.",
      variant: "warning",
      labelAccept: "Enviar solicitud",
      labelCancel: "Cancelar",
      size: "w-[411px] h-[294px]",
      onAccept: () => {
        submitSolitud();
      },
    },
    stepSuccess: {
      title: "¡Generaste tu solicitud con éxito!",
      message: "Ahora tu superior inmediato tiene que aprobarla. | ¿Querés ver el estado de tu gestión o cargar una nueva solicitud? Podés hacerlo desde la sección Mis Solicitudes.",
      variant: "success",
      labelAccept: "Ir a Mis solicitudes",
      labelCancel: "",
      size: "w-[419px] h-[354px]",
      onAccept: () => {
        redirectToMisSolictudes();
      },
    },
    stepCancel: {
      title: "Descartar Solicitud",
      message: "Si la descartás, se eliminarán todos los comprobantes cargados. Esta acción no se puede deshacer.",
      variant: "warning",
      labelAccept: "Descartar Solicitud",
      labelCancel: "Cancelar",
      size: "w-[411px] h-[335px]",
      onAccept: () => {
        redirectToMisSolictudes();
      },
    },
    stepEnviando: {
      title: "Procesando solicitud...",
      message: "Por favor espera.",
      variant: "loading",
      labelAccept: "",
      labelCancel: "",
      size: "w-[411px] h-[294px]",
      onAccept: () => { },
    },
    stepError: {
      title: "Error al enviar la solicitud",
      message: "Hubo un problema al intentar enviar la solicitud. Verificá tu conexión a internet y volvé a intentarlo nuevamente.",
      variant: "error",
      labelAccept: "Ir a Mis solicitudes",
      labelCancel: "",
      size: "w-[411px] h-[294px]",
      onAccept: () => {
        navigate(`/`);
        //setOpenMessagesModal(false);
      },
    }
  };

  const estadoActual = () => {
    switch (estado) {
      case estados.enviar:
        return steps.stepWarning;
      case estados.envioExitoso:
        return steps.stepSuccess;
      case estados.envioErroneo:
        return steps.stepError;
      case estados.cancelar:
        return steps.stepCancel;
      default:
        return steps.stepEnviando;
    }
  };
  //#endregion

  const confirmarSubmit = () => {
    // TODO: Agregar validaciones adicionales
    setIsSuccessEnvioSolicitud(false);
    setEstado(estados.enviar);
    setOpenMessagesModal(true);
  };

  const submitSolitud = () => {
    setOpenMessagesModal(false);
    setIsSubmitting(true);
    createSolicitud({ cabecera: { idTipoSolicitud }, comprobantes: listadoComprobantes })
      .then(() => {
        setIsSuccessEnvioSolicitud(true);
        setEstado(estados.envioExitoso);
        setOpenMessagesModal(true);
      })
      .catch((error) => {
        setIsSubmitting(false);
        setIsSuccessEnvioSolicitud(false);
        setEstado(estados.envioErroneo);
        setOpenMessagesModal(true);
        console.error("Error al enviar la solicitud:", error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const cancelSolicitud = () => {
    setEstado(estados.cancelar);
    setOpenMessagesModal(true);
  };

  const cancelarAgregarSolicitud = () => {
    // Si no hay datos en la grilla redirecciono
    if (listadoComprobantes.length === 0) {
      redirectToMisSolictudes();
      return false;
    }
    return true;
  }

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpenModalFiltros(false);
      }
    };
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    setTotal(0);
    setNoEnviarSolicitud(listadoComprobantes.length == 0);
    let total = 0
    listadoComprobantes.map((dato) => {
      total = parseFloat(total) + parseFloat(dato.importe);
    });
    setTotal(total)
  }, [listadoComprobantes]);

  const colorBadge = () => {
    switch (location.pathname.split("/")[2]) {
      case "reintegro-en-cuenta":
        return "tag-light-blue";
      case "reintegro-en-efectivo":
        return "tag-blue";
      case "anticipo-en-cuenta":
        return "tag-green";
      case "anticipo-en-efectivo":
        return "tag-dark-blue";
      default: // redirecciona por no soportarlo
        redirectToMisSolictudes();
    }
  };

  const tituloPantalla = () => {
    const titulo = location.pathname.split("/")[2].replace(/-/g, " ");

    return titulo.charAt(0).toUpperCase() + titulo.slice(1);
  };

  return (
    <div
      className={`container mx-auto flex flex-col h-full min-h-[800px] items-center my-8 px-2 xl:px-8`}>
      <div className="w-full flex flex-col justify-center gap-y-1 p-2">
        <Breadcrumb
          customItems={getBreadCrumbs()}
          onClick={(href) => {
            if (href) navigate(href);
          }}
        />
      </div>
      <div className="w-full flex flex-col justify-between p-1">
        <Text variant="h6" className="text-primary-10 py-1">
          Nueva solicitud
        </Text>
        <Text variant="body2 text-tertiary-0">
          Cargá los comprobantes asociados al tipo de solicitud que necesitás
          enviar.
        </Text>
      </div>
      <div className="w-full flex flex-row justify-between gap-y-1 pt-4 pb-3">
        <Badge variant={colorBadge()} className="border-l-[8px]">
          {tituloPantalla()}
        </Badge>
        {
          !location.pathname.includes("nueva-solicitud") && <OutlineButton onClick={() => {
            setDatoDelComprobante(false)
            setOpenModalFiltros(true)
          }}>
            + Agregar comprobante
          </OutlineButton>
        }

      </div>
      <div className="w-full min-h-[300px] flex flex-col gap-y-2 my-2">
        <Table
          selectable={false}
          data={listadoComprobantesTabla}
          columns={columnasComprobantes}
          selected={selectedRow}
        />
      </div>
      <div className="flex w-full pt-5 pb-5">
        {/* TODO: pasar este tag de totales a componente de DS */}
        <Text variant="body1" className="ml-auto">
          Total{" "}
          <span className="border-[1.5px] border-tertiary-90 px-2 py-[5px] text-tertiary-10 rounded text-nowrap inline-block w-[123px] text-right ml-5">
            $ {total?.toLocaleString('es-AR') || 0}
          </span>
        </Text>
      </div>
      <div className="flex w-full">
        <TextButton
          className="mx-2 ml-auto"
          size="small"
          onClick={cancelSolicitud}>
          Cancelar
        </TextButton>
        <PrimaryButton
          className=""
          size="small"
          onClick={confirmarSubmit}
          disabled={noEnviarSolicitud}>
          Enviar solicitud
        </PrimaryButton>
      </div>

      <NuevaSolicitudModal
        openModalFiltros={openModalFiltros}
        setOpenModalFiltros={setOpenModalFiltros}
        datos={datoDelComprobante}
        formFilter={{}}
        titulo={tituloPantalla()}
        color={colorBadge()}
        // TODO: cambiar el nombre de todo lo que se llama filter o filtro de este modal, no tiene nada que ver con filtros
        setFormFilter={cancelarAgregarSolicitud()}
        validacionesModal={false}
        chipsFiltrosModal={null}
        onSetNuevoComprobante={onSetNuevosComprobantes}
        idTipoSolicitud={idTipoSolicitud}
        cargando={false}
      />
      <MessagesModal
        openMessagesModal={openMessagesModal}
        setOpenMessagesModal={setOpenMessagesModal}
        isSuccessEnvioSolicitud={isSuccessEnvioSolicitud}
        size={estadoActual().size}
        onAccept={() => {
          !isSubmitting && estadoActual().onAccept();
        }}
        title={estadoActual().title}
        message={estadoActual().message}
        variant={estadoActual().variant}
        labelAccept={estadoActual().labelAccept}
        labelCancel={estadoActual().labelCancel}
      />
      <ModalComprobante closeModal={() => setOpenModalFile(false)} adjunto={fileToShow} isModalOpen={openModalFile} />
    </div >
  );
}

function getBreadCrumbs() {
  return [
    { label: "Inicio", href: "/", disabled: false },
    { label: "Nueva Solicitud", disabled: true },
  ];
}